import React from 'react';
import { useHistory } from 'react-router-dom';
import { Icon, message, notification } from 'antd';
import Btn from '../../../../../../components/btn';
import { useFormMethods } from '../../../../../../helpers/formManager';
import { dateFormats } from '../../../../shared/packages/dateTime';
import {
  getErrorMessage,
  useSetRoomsIndividualDatesMutation,
} from '../../../../api/setRoomsIndividualDates';
import { useAcceptanceViewFlatsInvalidate } from '../../../../api/acceptanceViewFlats';
import { paths } from '../../../../shared/configs/routing';
import { roomsTableSearchParamKeys } from '../../../../shared/configs/searchParams';
import { actionsEnum, dateSettingValueEnum, fieldNames } from '../../constants';
import { declOfNum } from '../../../../../../helpers/dspx-utils';

const newConfigFail = (flagAction) => {
  message.error(getErrorMessage(flagAction));
};

const Save = () => {
  const history = useHistory();

  const { handleSubmit } = useFormMethods();

  const invalidateRooms = useAcceptanceViewFlatsInvalidate();

  const { mutate, isLoading } = useSetRoomsIndividualDatesMutation({
    onSuccess: (data, variables) => {
      const { flagAction } = variables;

      if (!data.success) {
        newConfigFail(flagAction);
        return;
      }

      if (Object.hasOwn(data, 'countSuccess')) {
        const { countSuccess } = data;

        if (countSuccess === 0) {
          newConfigFail(flagAction);
          return;
        }

        if (countSuccess < variables[fieldNames.addresses].length) {
          notification.warning({
            message: 'Внимание',
            description: getNotificationMessage(flagAction, countSuccess),
          });
        }
      }

      const {
        push,
        location: { state, search },
      } = history;

      invalidateRooms();

      push({
        pathname: paths.main,
        search: createSearchParams({
          prevSearch: state?.from?.location?.search || '',
          currentSearch: search,
        }),
      });
    },
  });

  const onSubmit = async (values) => {
    const {
      location: { state },
    } = history;

    const payload = {
      ...normalizeValues(values),
      acceptanceId: state?.from?.acceptance?.id,
    };

    mutate(payload);
  };

  return (
    <Btn onClick={handleSubmit(onSubmit)} disabled={isLoading}>
      <span>Сохранить</span>
      <Icon type={isLoading ? 'loading' : 'check'} style={{ height: '14px' }} />
    </Btn>
  );
};

export default Save;

function createSearchParams({ prevSearch, currentSearch }) {
  const prev = new URLSearchParams(prevSearch);
  const search = new URLSearchParams(currentSearch);

  roomsTableSearchParamKeys.forEach((key) => {
    const value = search.get(key);
    !value ? prev.delete(key) : prev.set(key, value);
  });

  return prev.toString();
}

const cleanableDatePayloads = {
  [dateSettingValueEnum.START_DATE]: { [fieldNames.startDate]: '1' },
  [dateSettingValueEnum.END_DATE]: { [fieldNames.endDate]: '1' },
  [dateSettingValueEnum.PERIOD]: {
    [fieldNames.startDate]: '1',
    [fieldNames.endDate]: '1',
  },
};

function normalizeValues(values) {
  const action = values[fieldNames.action];

  if (action === actionsEnum.CLEAR) {
    return {
      flagAction: false,
      [fieldNames.addresses]: values[fieldNames.addresses],
      ...cleanableDatePayloads[values[fieldNames.cleanableDateEntity]],
    };
  }

  if (action === actionsEnum.SET) {
    const result = {
      flagAction: true,
      [fieldNames.addresses]: values[fieldNames.addresses],
    };

    if (values[fieldNames.startDate]) {
      result[fieldNames.startDate] = values[fieldNames.startDate].format(
        dateFormats.ISO
      );
    }

    if (values[fieldNames.endDate]) {
      result[fieldNames.endDate] = values[fieldNames.endDate].format(
        dateFormats.ISO
      );
    }

    return result;
  }

  return values;
}

function decl(count) {
  return `${count} ${declOfNum(count, [
    'помещения',
    'помещений',
    'помещений',
  ])}`;
}
function getNotificationMessage(flagAction, count) {
  const text = decl(count);

  return flagAction
    ? `Индивидуальные даты установились для ${text}`
    : `Индивидуальные даты очистились у ${text}`;
}
